import React, { Component } from 'react'
import { Row, Col } from 'reactstrap'

export class AttentionHeaderComponent extends Component {
    render () {
        return (
          <Row className="header audience attention">
            <Col>
              <ul className="hFirstRow balanceVerticalAlign">
                <li className="imgHolder">
                  <div id='attention_header_img'>
                    <img src="/static/images/insights_black.svg" alt="logo" className="imgThumb" onError={(e)=>{e.target.style = 'display: none;';}} />
                  </div>
                </li>
                <li>
                  <h2 className="title">Attention Index</h2>
                </li>
              </ul>
            </Col>
          </Row>
        )
    }
}

export default AttentionHeaderComponent
